import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { errText } from "@/components/pageSettings/AdminModal";
import { Choice } from "./ThankYouTestSetup";

const OVERLAP = [["buyer_first", "The buyer's own test takes priority"], ["block", "Don't allow both at once"]];
const STATUS = { running: "Running", pending: "Waiting for approval", finished: "Finished" };

// Overall panel footer: the overlap rule and the buyer tests happening right now.
export function ThankYouTestPolicy({ overlap, onSaved }) {
  const [tests, setTests] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/thankyou-buyer-tests").then((r) => setTests(r.data.tests)).catch(() => setTests([])); }, []);
  const save = async (v) => {
    setBusy(true);
    try {
      await api.put("/admin/thankyou-test-policy", { overlap: v });
      onSaved(v);
      toast.success("Saved");
    } catch (e) {
      toast.error(errText(e, "Couldn't save"));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="space-y-2 border-t-2 border-black pt-3" data-testid="ty-test-policy">
      <div className="md:w-1/2">
        <Choice label="If a buyer has their own test while this one runs" value={overlap || "buyer_first"} options={OVERLAP}
          onChange={save} disabled={busy} testId="ty-test-overlap" />
      </div>
      <div className="label-mono">Buyer tests</div>
      {tests && !tests.length && <p className="text-[12px] text-zinc-500" data-testid="ty-test-buyer-tests-empty">No buyer tests right now. Start one from a buyer's row (Design test).</p>}
      {(tests || []).map((b) => (
        <div key={b.page_id} className="flex flex-wrap gap-x-3 text-sm" data-testid={`ty-test-buyer-${b.page_id}`}>
          <b>{b.firm_name || b.buyer}</b>
          <span>{STATUS[b.status]}</span>
          <span className="text-zinc-500">{b.status === "running" ? `Leading: ${b.leader_name || "—"}` : `Winner: ${b.winner_name || "—"}`}</span>
        </div>
      ))}
    </div>
  );
}
